<template>
  <div>
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">You will restrict access to the factfinder</h5>
    </div>
    <div class="modal-body">
      <p>The form can only be accessed by a client logging in using a code.</p>
      <p>The code will be sent via email during the login flow (Passwordless Login).</p>
    </div>
    <div class="mt-3 lay-card-bottom modal-footer">
      <VEditButton class="b-100 eb-sec" @click="$emit('cancel')">Cancel</VEditButton>
      <VEditButton class="b-100 eb-prim"  @click="$emit('ok')">Ok</VEditButton>
    </div>
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped>

</style>